import React, { useEffect, useMemo, useRef, useState } from "react";

import "./howitworks.css";

import ScrollFadeBackground from './scrollfadebackground'
import ScrollFadeBackgroundMobile from './scrollfadebackgroundmobile'

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);
useEffect(() => {
  const checkMobile = () => setIsMobile(window.innerWidth < breakpoint);
  checkMobile(); // Check on mount

  window.addEventListener('resize', checkMobile);
  return () => window.removeEventListener('resize', checkMobile);
}, [breakpoint]);

return isMobile;
}

export default function FadeTesting() {

  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <ScrollFadeBackground/>
    )
  } else {
    return(
    <ScrollFadeBackground fadeDistanceVh={140}>
  <section className="fadeSection" style={{ minHeight: "120vh" }}>
    {/* content that starts light and transitions */}
    jijijij
  </section>

  <section className="darkSection" style={{ minHeight: "120vh" }}>
    {/* your dark part of site */}
    nijijk
  </section>
</ScrollFadeBackground>
)
  }
}
